import { columnSettings, tableWidth } from "./report-template-setting";

const settings = {};
for (let columnSetting of columnSettings) {
  settings[columnSetting.field] = columnSetting;
}

const ReportTemplateGroupHeader = (props) => {
  const { id, mykey, product_name } = props.group_data;

  return (
    <tr
      key={`${mykey}-group-header-${props.group_label}`}
      className={`row-start-start ${tableWidth} text-sm text-slate-700 `}
    >
      <td
        className={`row-start-start w-full border-zinc-300 border border-t-0  px-2 pt-4 pb-2 gap-2 font-semibold pl-4`}
      >
        <span className="underline">{product_name}</span>
      </td>
    </tr>
  );
};

export default ReportTemplateGroupHeader;
